export const UNSIGNED = "unsigned";
export const SIGNED = "signed";
export const OTHER = "Other";